var map = {
	"./insaneannouncer.com/config": [
		17854,
		3,
		7854
	],
	"./insaneannouncer.com/config.json": [
		17854,
		3,
		7854
	],
	"./insaneannouncer.com/images/1.gif": [
		44604,
		1,
		4604
	],
	"./insaneannouncer.com/images/2.gif": [
		73000,
		1,
		3000
	],
	"./insaneannouncer.com/images/banner.png": [
		22287,
		1,
		2287
	],
	"./insaneannouncer.com/images/logo.png": [
		428,
		1,
		428
	],
	"./insaneannouncer.com/updates": [
		84850,
		3,
		4850
	],
	"./insaneannouncer.com/updates.json": [
		84850,
		3,
		4850
	],
	"./insaneannouncer.com/wiki/faq/index.md": [
		49861,
		1,
		9861
	],
	"./insaneannouncer.com/wiki/features/index.md": [
		87167,
		1,
		7167
	],
	"./insaneannouncer.com/wiki/installation/index.md": [
		43787,
		1,
		3787
	],
	"./insaneannouncer.com/wiki/installation/language.md": [
		39201,
		1,
		9957
	],
	"./insaneannouncer.com/wiki/installation/proxy.md": [
		56602,
		1,
		6602
	],
	"./insaneannouncer.com/wiki/installation/server.md": [
		25114,
		1,
		5114
	],
	"./insaneannouncer.com/wiki/installation/troubleshooting.md": [
		55326,
		1,
		5326
	],
	"./insaneannouncer.com/wiki/overview/commands.md": [
		72683,
		1,
		2683
	],
	"./insaneannouncer.com/wiki/overview/index.md": [
		86940,
		1,
		6940
	],
	"./insaneannouncer.com/wiki/wiki": [
		19201,
		3,
		9201
	],
	"./insaneannouncer.com/wiki/wiki.json": [
		19201,
		3,
		9201
	],
	"./insaneshops.com/config": [
		50690,
		3,
		690
	],
	"./insaneshops.com/config.json": [
		50690,
		3,
		690
	],
	"./insaneshops.com/images/1.gif": [
		94086,
		1,
		4086
	],
	"./insaneshops.com/images/2.gif": [
		38943,
		1,
		8943
	],
	"./insaneshops.com/images/3.gif": [
		87000,
		1,
		7000
	],
	"./insaneshops.com/images/banner.png": [
		65089,
		1,
		5089
	],
	"./insaneshops.com/images/logo.png": [
		75426,
		1,
		5426
	],
	"./insaneshops.com/updates": [
		35726,
		3,
		5726
	],
	"./insaneshops.com/updates.json": [
		35726,
		3,
		5726
	],
	"./insaneshops.com/wiki/api/index.md": [
		11599,
		1,
		1599
	],
	"./insaneshops.com/wiki/faq/index.md": [
		18264,
		1,
		8264
	],
	"./insaneshops.com/wiki/features/index.md": [
		6716,
		1,
		6716
	],
	"./insaneshops.com/wiki/features/multi_currency.md": [
		64151,
		1,
		4151
	],
	"./insaneshops.com/wiki/installation/index.md": [
		34525,
		1,
		4525
	],
	"./insaneshops.com/wiki/installation/language.md": [
		83106,
		1,
		3106
	],
	"./insaneshops.com/wiki/installation/server.md": [
		65390,
		1,
		5390
	],
	"./insaneshops.com/wiki/overview/commands.md": [
		41695,
		1,
		1695
	],
	"./insaneshops.com/wiki/overview/index.md": [
		14827,
		1,
		4827
	],
	"./insaneshops.com/wiki/overview/permissions.md": [
		28216,
		1,
		8216
	],
	"./insaneshops.com/wiki/wiki": [
		20871,
		3,
		871
	],
	"./insaneshops.com/wiki/wiki.json": [
		20871,
		3,
		871
	],
	"./insanespawners.com/config": [
		96850,
		3,
		6850
	],
	"./insanespawners.com/config.json": [
		96850,
		3,
		6850
	],
	"./insanespawners.com/images/1.gif": [
		3372,
		1,
		3372
	],
	"./insanespawners.com/images/2.gif": [
		89373,
		1,
		9373
	],
	"./insanespawners.com/images/3.gif": [
		57428,
		1,
		7428
	],
	"./insanespawners.com/images/banner.png": [
		12123,
		1,
		2123
	],
	"./insanespawners.com/images/logo.png": [
		42135,
		1,
		2135
	],
	"./insanespawners.com/updates": [
		85036,
		3,
		5036
	],
	"./insanespawners.com/updates.json": [
		85036,
		3,
		5036
	],
	"./insanespawners.com/wiki/api/index.md": [
		7280,
		1,
		7280
	],
	"./insanespawners.com/wiki/faq/index.md": [
		23857,
		1,
		3857
	],
	"./insanespawners.com/wiki/features/index.md": [
		15773,
		1,
		5773
	],
	"./insanespawners.com/wiki/installation/index.md": [
		86964,
		1,
		6964
	],
	"./insanespawners.com/wiki/installation/language.md": [
		48383,
		1,
		8383
	],
	"./insanespawners.com/wiki/installation/server.md": [
		30050,
		1,
		50
	],
	"./insanespawners.com/wiki/overview/commands.md": [
		42122,
		1,
		2122
	],
	"./insanespawners.com/wiki/overview/index.md": [
		63276,
		1,
		3276
	],
	"./insanespawners.com/wiki/overview/permissions.md": [
		51142,
		1,
		1142
	],
	"./insanespawners.com/wiki/wiki": [
		24784,
		3,
		4784
	],
	"./insanespawners.com/wiki/wiki.json": [
		24784,
		3,
		4784
	],
	"./insanevaults.com/config": [
		47847,
		3,
		7847
	],
	"./insanevaults.com/config.json": [
		47847,
		3,
		7847
	],
	"./insanevaults.com/images/1.gif": [
		65161,
		1,
		5161
	],
	"./insanevaults.com/images/2.gif": [
		57154,
		1,
		7154
	],
	"./insanevaults.com/images/3.gif": [
		68329,
		1,
		8329
	],
	"./insanevaults.com/images/4.gif": [
		32531,
		1,
		4464
	],
	"./insanevaults.com/images/5.gif": [
		65348,
		1,
		5348
	],
	"./insanevaults.com/images/6.gif": [
		95802,
		1,
		5802
	],
	"./insanevaults.com/images/F1.gif": [
		83341,
		1,
		3341
	],
	"./insanevaults.com/images/F2.gif": [
		53457,
		1,
		3457
	],
	"./insanevaults.com/images/F3.gif": [
		81925,
		1,
		1925
	],
	"./insanevaults.com/images/F4.gif": [
		38521,
		1,
		8521
	],
	"./insanevaults.com/images/U1.gif": [
		35134,
		1,
		5134
	],
	"./insanevaults.com/images/U2.gif": [
		40215,
		1,
		215
	],
	"./insanevaults.com/images/U3.gif": [
		16922,
		1,
		6922
	],
	"./insanevaults.com/images/U4.gif": [
		87486,
		1,
		7486
	],
	"./insanevaults.com/images/U5.gif": [
		8106,
		1,
		8106
	],
	"./insanevaults.com/images/U6.gif": [
		26020,
		1,
		6020
	],
	"./insanevaults.com/images/banner.png": [
		87659,
		1,
		7659
	],
	"./insanevaults.com/images/logo.png": [
		52833,
		1,
		2833
	],
	"./insanevaults.com/updates": [
		83748,
		3,
		3748
	],
	"./insanevaults.com/updates.json": [
		83748,
		3,
		3748
	],
	"./insanevaults.com/wiki/faq/index.md": [
		71631,
		1,
		1631
	],
	"./insanevaults.com/wiki/features/communityvault.md": [
		82302,
		1,
		2302
	],
	"./insanevaults.com/wiki/features/customcommandalias.md": [
		52182,
		1,
		2182
	],
	"./insanevaults.com/wiki/features/index.md": [
		10802,
		1,
		802
	],
	"./insanevaults.com/wiki/features/vaultextendsinventory.md": [
		49016,
		1,
		9016
	],
	"./insanevaults.com/wiki/features/vaultpurge.md": [
		90787,
		1,
		2478
	],
	"./insanevaults.com/wiki/features/vaulttypes.md": [
		40368,
		1,
		921
	],
	"./insanevaults.com/wiki/installation/import.md": [
		52992,
		1,
		2992
	],
	"./insanevaults.com/wiki/installation/index.md": [
		95672,
		1,
		5672
	],
	"./insanevaults.com/wiki/installation/language.md": [
		72475,
		1,
		2475
	],
	"./insanevaults.com/wiki/installation/proxy.md": [
		10425,
		1,
		425
	],
	"./insanevaults.com/wiki/installation/server.md": [
		21114,
		1,
		1114
	],
	"./insanevaults.com/wiki/installation/troubleshooting.md": [
		35429,
		1,
		5429
	],
	"./insanevaults.com/wiki/overview/commands.md": [
		26891,
		1,
		6891
	],
	"./insanevaults.com/wiki/overview/index.md": [
		61201,
		1,
		1201
	],
	"./insanevaults.com/wiki/overview/permissions.md": [
		83589,
		1,
		3589
	],
	"./insanevaults.com/wiki/overview/placeholders.md": [
		51918,
		1,
		1918
	],
	"./insanevaults.com/wiki/wiki": [
		63794,
		3,
		3794
	],
	"./insanevaults.com/wiki/wiki.json": [
		63794,
		3,
		3794
	],
	"./techscode.com/config": [
		42090,
		3,
		2090
	],
	"./techscode.com/config.json": [
		42090,
		3,
		2090
	],
	"./techscode.com/images/background.png": [
		29688,
		1,
		9688
	],
	"./techscode.com/images/insaneannouncer_transparant.png": [
		79426,
		1,
		9426
	],
	"./techscode.com/images/insaneshops_transparant.png": [
		55214,
		1,
		5214
	],
	"./techscode.com/images/logo.png": [
		9950,
		1,
		9950
	],
	"./techscode.com/images/t-icon_main_dark-bg_512px.gif": [
		62297,
		1,
		2297
	],
	"./techscode.com/images/tech.png": [
		52431,
		1,
		2431
	],
	"./techscode.com/images/techStar.gif": [
		4977,
		1,
		4977
	],
	"./techscode.com/images/ultracustomizer_transparant.png": [
		52712,
		1,
		2712
	],
	"./techscode.com/images/ultraeconomy_transparant.png": [
		3142,
		1,
		3142
	],
	"./techscode.com/images/ultramotd_transparant.png": [
		29049,
		1,
		9049
	],
	"./techscode.com/images/ultrapermissions_transparant.png": [
		44679,
		1,
		4679
	],
	"./techscode.com/images/ultrapunishments_transparant.png": [
		13465,
		1,
		3465
	],
	"./techscode.com/images/ultraregions_transparant.png": [
		66182,
		1,
		6182
	],
	"./techscode.com/images/ultrascoreboards_transparant.png": [
		24149,
		1,
		4149
	],
	"./techscode.com/terms-of-service.md": [
		40271,
		1,
		271
	],
	"./ultracustomizer.com/config": [
		3196,
		3,
		3196
	],
	"./ultracustomizer.com/config.json": [
		3196,
		3,
		3196
	],
	"./ultracustomizer.com/images/1.gif": [
		3159,
		1,
		3159
	],
	"./ultracustomizer.com/images/2.gif": [
		40475,
		1,
		475
	],
	"./ultracustomizer.com/images/3.gif": [
		61018,
		1,
		1018
	],
	"./ultracustomizer.com/images/4.gif": [
		39654,
		1,
		9654
	],
	"./ultracustomizer.com/images/banner.png": [
		64820,
		1,
		4820
	],
	"./ultracustomizer.com/images/logo.png": [
		94375,
		1,
		4375
	],
	"./ultracustomizer.com/updates": [
		12699,
		3,
		2699
	],
	"./ultracustomizer.com/updates.json": [
		12699,
		3,
		2699
	],
	"./ultracustomizer.com/wiki/addons/anvil-text-input.md": [
		75859,
		1,
		5859
	],
	"./ultracustomizer.com/wiki/addons/armor.md": [
		56865,
		1,
		6865
	],
	"./ultracustomizer.com/wiki/addons/bed-wars.md": [
		43401,
		1,
		8954
	],
	"./ultracustomizer.com/wiki/addons/better-compared-elements.md": [
		76996,
		1,
		6996
	],
	"./ultracustomizer.com/wiki/addons/bossbar-message.md": [
		97029,
		1,
		7029
	],
	"./ultracustomizer.com/wiki/addons/bungeecord.md": [
		70413,
		1,
		413
	],
	"./ultracustomizer.com/wiki/addons/citizens.md": [
		80889,
		1,
		889
	],
	"./ultracustomizer.com/wiki/addons/downloads.md": [
		44388,
		1,
		4388
	],
	"./ultracustomizer.com/wiki/addons/fly-toggle.md": [
		89284,
		1,
		9284
	],
	"./ultracustomizer.com/wiki/addons/gamemode-changer.md": [
		24511,
		1,
		4511
	],
	"./ultracustomizer.com/wiki/addons/geysermc.md": [
		67032,
		1,
		7032
	],
	"./ultracustomizer.com/wiki/addons/httptools.md": [
		28269,
		1,
		8269
	],
	"./ultracustomizer.com/wiki/addons/index.md": [
		35762,
		1,
		5762
	],
	"./ultracustomizer.com/wiki/addons/inventory-utils.md": [
		1978,
		1,
		1978
	],
	"./ultracustomizer.com/wiki/addons/locale.md": [
		4437,
		1,
		4437
	],
	"./ultracustomizer.com/wiki/addons/operators.md": [
		37717,
		1,
		7717
	],
	"./ultracustomizer.com/wiki/addons/player-kill.md": [
		20975,
		1,
		975
	],
	"./ultracustomizer.com/wiki/addons/player-stepped-on-block.md": [
		41565,
		1,
		1565
	],
	"./ultracustomizer.com/wiki/addons/player-velocity-utils.md": [
		96300,
		1,
		6300
	],
	"./ultracustomizer.com/wiki/addons/player.md": [
		29789,
		1,
		9789
	],
	"./ultracustomizer.com/wiki/addons/potion-apply.md": [
		29057,
		1,
		9057
	],
	"./ultracustomizer.com/wiki/addons/random-elements.md": [
		83825,
		1,
		3825
	],
	"./ultracustomizer.com/wiki/addons/read-txt-file.md": [
		82135,
		1,
		7419
	],
	"./ultracustomizer.com/wiki/addons/shift-right-click.md": [
		36470,
		1,
		6470
	],
	"./ultracustomizer.com/wiki/addons/sneaking.md": [
		8754,
		1,
		8754
	],
	"./ultracustomizer.com/wiki/addons/spigot.md": [
		91383,
		1,
		1383
	],
	"./ultracustomizer.com/wiki/addons/string-converter.md": [
		58839,
		1,
		8839
	],
	"./ultracustomizer.com/wiki/addons/survival-games.md": [
		47007,
		1,
		7007
	],
	"./ultracustomizer.com/wiki/addons/text-component.md": [
		63020,
		1,
		3020
	],
	"./ultracustomizer.com/wiki/addons/text-utils.md": [
		55929,
		1,
		5929
	],
	"./ultracustomizer.com/wiki/addons/ultra-permissions.md": [
		19265,
		1,
		9265
	],
	"./ultracustomizer.com/wiki/addons/variables.md": [
		46990,
		1,
		6990
	],
	"./ultracustomizer.com/wiki/addons/vault.md": [
		39944,
		1,
		9944
	],
	"./ultracustomizer.com/wiki/addons/viaversion.md": [
		13342,
		1,
		3342
	],
	"./ultracustomizer.com/wiki/addons/votifier.md": [
		87181,
		1,
		7181
	],
	"./ultracustomizer.com/wiki/addons/weather-events.md": [
		63179,
		1,
		3179
	],
	"./ultracustomizer.com/wiki/addons/webhooks.md": [
		91817,
		1,
		1817
	],
	"./ultracustomizer.com/wiki/api/index.md": [
		42919,
		1,
		2919
	],
	"./ultracustomizer.com/wiki/elements/block-vanilla-behaviour.md": [
		39355,
		1,
		9355
	],
	"./ultracustomizer.com/wiki/elements/broadcast.md": [
		16561,
		1,
		6561
	],
	"./ultracustomizer.com/wiki/elements/clear-inventory.md": [
		97961,
		1,
		7961
	],
	"./ultracustomizer.com/wiki/elements/compare-item.md": [
		40186,
		1,
		186
	],
	"./ultracustomizer.com/wiki/elements/compare-string.md": [
		21493,
		1,
		1493
	],
	"./ultracustomizer.com/wiki/elements/console-command.md": [
		20464,
		1,
		464
	],
	"./ultracustomizer.com/wiki/elements/execute-for-all-players.md": [
		77811,
		1,
		7811
	],
	"./ultracustomizer.com/wiki/elements/get-all-arguments-as-string.md": [
		15393,
		1,
		5393
	],
	"./ultracustomizer.com/wiki/elements/get-first-argument.md": [
		69743,
		1,
		9743
	],
	"./ultracustomizer.com/wiki/elements/get-material-of-block.md": [
		11243,
		1,
		1243
	],
	"./ultracustomizer.com/wiki/elements/get-placeholder.md": [
		19701,
		1,
		9701
	],
	"./ultracustomizer.com/wiki/elements/get-player-from-name.md": [
		8470,
		1,
		8470
	],
	"./ultracustomizer.com/wiki/elements/get-player-name.md": [
		64916,
		1,
		4916
	],
	"./ultracustomizer.com/wiki/elements/get-player-uuid.md": [
		85820,
		1,
		5820
	],
	"./ultracustomizer.com/wiki/elements/give-item.md": [
		59175,
		1,
		9175
	],
	"./ultracustomizer.com/wiki/elements/give-levels.md": [
		50191,
		1,
		2194
	],
	"./ultracustomizer.com/wiki/elements/give-material.md": [
		46090,
		1,
		6090
	],
	"./ultracustomizer.com/wiki/elements/greater-than-or-equal-to.md": [
		59745,
		1,
		9745
	],
	"./ultracustomizer.com/wiki/elements/greater-than.md": [
		28095,
		1,
		8095
	],
	"./ultracustomizer.com/wiki/elements/has-arguments.md": [
		26725,
		1,
		6725
	],
	"./ultracustomizer.com/wiki/elements/has-permission.md": [
		13885,
		1,
		3885
	],
	"./ultracustomizer.com/wiki/elements/index.md": [
		46446,
		1,
		6446
	],
	"./ultracustomizer.com/wiki/elements/less-than-or-equal-to.md": [
		47301,
		1,
		7301
	],
	"./ultracustomizer.com/wiki/elements/less-than.md": [
		7145,
		1,
		7145
	],
	"./ultracustomizer.com/wiki/elements/number-to-text.md": [
		20391,
		1,
		391
	],
	"./ultracustomizer.com/wiki/elements/number-user-input.md": [
		62773,
		1,
		2773
	],
	"./ultracustomizer.com/wiki/elements/offline-player-selector.md": [
		29979,
		1,
		9979
	],
	"./ultracustomizer.com/wiki/elements/online-player-selector.md": [
		76840,
		1,
		6840
	],
	"./ultracustomizer.com/wiki/elements/open-gui.md": [
		51975,
		1,
		1975
	],
	"./ultracustomizer.com/wiki/elements/play-sound.md": [
		65192,
		1,
		5192
	],
	"./ultracustomizer.com/wiki/elements/player-actionbar-message.md": [
		39417,
		1,
		9417
	],
	"./ultracustomizer.com/wiki/elements/player-close-inventory.md": [
		41027,
		1,
		1027
	],
	"./ultracustomizer.com/wiki/elements/player-command-ignore-permission.md": [
		87317,
		1,
		7317
	],
	"./ultracustomizer.com/wiki/elements/player-command.md": [
		20249,
		1,
		249
	],
	"./ultracustomizer.com/wiki/elements/player-message.md": [
		93174,
		1,
		3894
	],
	"./ultracustomizer.com/wiki/elements/player-online.md": [
		38730,
		1,
		8730
	],
	"./ultracustomizer.com/wiki/elements/random-30.md": [
		63346,
		1,
		3346
	],
	"./ultracustomizer.com/wiki/elements/random-50.md": [
		20191,
		1,
		191
	],
	"./ultracustomizer.com/wiki/elements/random-number.md": [
		77120,
		1,
		7120
	],
	"./ultracustomizer.com/wiki/elements/remove-item-from-player.md": [
		62161,
		1,
		2161
	],
	"./ultracustomizer.com/wiki/elements/send-player-title.md": [
		88612,
		1,
		8612
	],
	"./ultracustomizer.com/wiki/elements/seperate-click-types.md": [
		53010,
		1,
		3010
	],
	"./ultracustomizer.com/wiki/elements/set-food.md": [
		53231,
		1,
		3231
	],
	"./ultracustomizer.com/wiki/elements/set-health.md": [
		89595,
		1,
		9595
	],
	"./ultracustomizer.com/wiki/elements/set-material-of-block.md": [
		5364,
		1,
		5364
	],
	"./ultracustomizer.com/wiki/elements/set-velocity.md": [
		33851,
		1,
		3851
	],
	"./ultracustomizer.com/wiki/elements/text-user-input.md": [
		49414,
		1,
		9414
	],
	"./ultracustomizer.com/wiki/events/index.md": [
		54689,
		1,
		4689
	],
	"./ultracustomizer.com/wiki/faq/index.md": [
		58582,
		1,
		8582
	],
	"./ultracustomizer.com/wiki/features/index.md": [
		47922,
		1,
		7922
	],
	"./ultracustomizer.com/wiki/installation/index.md": [
		38751,
		1,
		8751
	],
	"./ultracustomizer.com/wiki/installation/language.md": [
		76973,
		1,
		6973
	],
	"./ultracustomizer.com/wiki/installation/mysql.md": [
		89256,
		1,
		9256
	],
	"./ultracustomizer.com/wiki/installation/server.md": [
		7261,
		1,
		7261
	],
	"./ultracustomizer.com/wiki/installation/troubleshooting.md": [
		2165,
		1,
		2165
	],
	"./ultracustomizer.com/wiki/overview/commands&permissions.md": [
		89469,
		1,
		9469
	],
	"./ultracustomizer.com/wiki/overview/commands.md": [
		23686,
		1,
		3686
	],
	"./ultracustomizer.com/wiki/overview/index.md": [
		16603,
		1,
		6603
	],
	"./ultracustomizer.com/wiki/scripts/block_break.md": [
		14629,
		1,
		4629
	],
	"./ultracustomizer.com/wiki/scripts/block_place.md": [
		21689,
		1,
		1689
	],
	"./ultracustomizer.com/wiki/scripts/food_level_change.md": [
		70354,
		1,
		354
	],
	"./ultracustomizer.com/wiki/scripts/index.md": [
		29791,
		1,
		9791
	],
	"./ultracustomizer.com/wiki/scripts/item_right_click.md": [
		77477,
		1,
		7477
	],
	"./ultracustomizer.com/wiki/scripts/player_chat_message.md": [
		74313,
		1,
		4313
	],
	"./ultracustomizer.com/wiki/scripts/player_death.md": [
		74470,
		1,
		4470
	],
	"./ultracustomizer.com/wiki/scripts/player_join.md": [
		96674,
		1,
		6674
	],
	"./ultracustomizer.com/wiki/scripts/player_quit.md": [
		23458,
		1,
		3458
	],
	"./ultracustomizer.com/wiki/scripts/repeating.md": [
		30150,
		1,
		150
	],
	"./ultracustomizer.com/wiki/scripts/right_click_on_block.md": [
		61753,
		1,
		9754
	],
	"./ultracustomizer.com/wiki/wiki": [
		56021,
		3,
		6021
	],
	"./ultracustomizer.com/wiki/wiki.json": [
		56021,
		3,
		6021
	],
	"./ultraeconomy.com/config": [
		78406,
		3,
		8406
	],
	"./ultraeconomy.com/config.json": [
		78406,
		3,
		8406
	],
	"./ultraeconomy.com/images/1.gif": [
		76469,
		1,
		6469
	],
	"./ultraeconomy.com/images/2.gif": [
		60050,
		1,
		400
	],
	"./ultraeconomy.com/images/3.gif": [
		62619,
		1,
		2619
	],
	"./ultraeconomy.com/images/4.gif": [
		38541,
		1,
		8541
	],
	"./ultraeconomy.com/images/banner.png": [
		91425,
		1,
		1425
	],
	"./ultraeconomy.com/images/logo.png": [
		31102,
		1,
		1102
	],
	"./ultraeconomy.com/updates": [
		75296,
		3,
		5296
	],
	"./ultraeconomy.com/updates.json": [
		75296,
		3,
		5296
	],
	"./ultraeconomy.com/wiki/api/gradle.md": [
		87364,
		1,
		7364
	],
	"./ultraeconomy.com/wiki/api/index.md": [
		41370,
		1,
		1370
	],
	"./ultraeconomy.com/wiki/api/instance.md": [
		97302,
		1,
		7302
	],
	"./ultraeconomy.com/wiki/api/maven.md": [
		35494,
		1,
		5494
	],
	"./ultraeconomy.com/wiki/faq/index.md": [
		65182,
		1,
		5182
	],
	"./ultraeconomy.com/wiki/features/bank.md": [
		13324,
		1,
		3324
	],
	"./ultraeconomy.com/wiki/features/currencies.md": [
		69166,
		1,
		9166
	],
	"./ultraeconomy.com/wiki/features/index.md": [
		532,
		1,
		532
	],
	"./ultraeconomy.com/wiki/features/mob_drops.md": [
		32226,
		1,
		2226
	],
	"./ultraeconomy.com/wiki/features/money_on_death.md": [
		26465,
		1,
		6465
	],
	"./ultraeconomy.com/wiki/features/trade.md": [
		91084,
		1,
		1084
	],
	"./ultraeconomy.com/wiki/installation/import.md": [
		33401,
		1,
		3401
	],
	"./ultraeconomy.com/wiki/installation/index.md": [
		22414,
		1,
		2414
	],
	"./ultraeconomy.com/wiki/installation/language.md": [
		59935,
		1,
		9935
	],
	"./ultraeconomy.com/wiki/installation/proxy.md": [
		21314,
		1,
		1314
	],
	"./ultraeconomy.com/wiki/installation/server.md": [
		37571,
		1,
		7571
	],
	"./ultraeconomy.com/wiki/installation/troubleshooting.md": [
		7916,
		1,
		7916
	],
	"./ultraeconomy.com/wiki/overview/commands.md": [
		43531,
		1,
		3531
	],
	"./ultraeconomy.com/wiki/overview/index.md": [
		94259,
		1,
		4259
	],
	"./ultraeconomy.com/wiki/overview/permissions.md": [
		28083,
		1,
		8083
	],
	"./ultraeconomy.com/wiki/overview/placeholders.md": [
		87877,
		1,
		7877
	],
	"./ultraeconomy.com/wiki/wiki": [
		6399,
		3,
		6399
	],
	"./ultraeconomy.com/wiki/wiki.json": [
		6399,
		3,
		6399
	],
	"./ultramotd.com/config": [
		50739,
		3,
		739
	],
	"./ultramotd.com/config.json": [
		50739,
		3,
		739
	],
	"./ultramotd.com/images/MOTD_BASIC_GIF.mp4": [
		6570,
		1,
		6570
	],
	"./ultramotd.com/images/MOTD_EVENT_GIF.mp4": [
		82308,
		1,
		2308
	],
	"./ultramotd.com/images/MOTD_MAINTENANCE_GIF.mp4": [
		4315,
		1,
		4315
	],
	"./ultramotd.com/images/MOTD_TIMER_GIF.mp4": [
		83663,
		1,
		3663
	],
	"./ultramotd.com/images/MOTD_WELCOME_GIF.mp4": [
		55795,
		1,
		5795
	],
	"./ultramotd.com/images/banner.png": [
		78034,
		1,
		8034
	],
	"./ultramotd.com/images/logo.png": [
		45549,
		1,
		5549
	],
	"./ultramotd.com/updates": [
		14760,
		3,
		4760
	],
	"./ultramotd.com/updates.json": [
		14760,
		3,
		4760
	],
	"./ultramotd.com/wiki/events/block-break.md": [
		31491,
		1,
		1491
	],
	"./ultramotd.com/wiki/events/block-damage.md": [
		42584,
		1,
		2584
	],
	"./ultramotd.com/wiki/events/block-grow.md": [
		7632,
		1,
		7632
	],
	"./ultramotd.com/wiki/events/block-piston-extend.md": [
		77913,
		1,
		7913
	],
	"./ultramotd.com/wiki/events/block-piston-retract.md": [
		7873,
		1,
		7873
	],
	"./ultramotd.com/wiki/events/block-place.md": [
		147,
		1,
		147
	],
	"./ultramotd.com/wiki/events/brew.md": [
		58195,
		1,
		8195
	],
	"./ultramotd.com/wiki/events/chunk-load.md": [
		66510,
		1,
		6510
	],
	"./ultramotd.com/wiki/events/chunk-unload.md": [
		246,
		1,
		246
	],
	"./ultramotd.com/wiki/events/craft-item.md": [
		27685,
		1,
		7685
	],
	"./ultramotd.com/wiki/events/enchant-item.md": [
		22709,
		1,
		2709
	],
	"./ultramotd.com/wiki/events/entity-breed.md": [
		50770,
		1,
		770
	],
	"./ultramotd.com/wiki/events/entity-death.md": [
		13895,
		1,
		3895
	],
	"./ultramotd.com/wiki/events/entity-explode.md": [
		11692,
		1,
		1692
	],
	"./ultramotd.com/wiki/events/entity-shoot-bow.md": [
		98126,
		1,
		8126
	],
	"./ultramotd.com/wiki/events/index.md": [
		53194,
		1,
		3194
	],
	"./ultramotd.com/wiki/events/inventory-close.md": [
		64132,
		1,
		4132
	],
	"./ultramotd.com/wiki/events/inventory-open.md": [
		43781,
		1,
		3781
	],
	"./ultramotd.com/wiki/events/lightning-strike.md": [
		23097,
		1,
		3097
	],
	"./ultramotd.com/wiki/events/note-play.md": [
		27342,
		1,
		7342
	],
	"./ultramotd.com/wiki/events/player-bed-enter.md": [
		76484,
		1,
		6484
	],
	"./ultramotd.com/wiki/events/player-bed-leave.md": [
		75966,
		1,
		5966
	],
	"./ultramotd.com/wiki/events/player-bucket-empty.md": [
		42644,
		1,
		2644
	],
	"./ultramotd.com/wiki/events/player-bucket-fill.md": [
		46966,
		1,
		6966
	],
	"./ultramotd.com/wiki/events/player-death.md": [
		68876,
		1,
		8876
	],
	"./ultramotd.com/wiki/events/player-drop-item.md": [
		92416,
		1,
		2416
	],
	"./ultramotd.com/wiki/events/player-egg-throw.md": [
		3871,
		1,
		3871
	],
	"./ultramotd.com/wiki/events/player-exp-change.md": [
		9025,
		1,
		9025
	],
	"./ultramotd.com/wiki/events/player-fish.md": [
		22413,
		1,
		2413
	],
	"./ultramotd.com/wiki/events/player-gamemode-change.md": [
		90095,
		1,
		95
	],
	"./ultramotd.com/wiki/events/player-item-break.md": [
		5107,
		1,
		5107
	],
	"./ultramotd.com/wiki/events/player-join.md": [
		67684,
		1,
		7684
	],
	"./ultramotd.com/wiki/events/player-kick.md": [
		98605,
		1,
		8605
	],
	"./ultramotd.com/wiki/events/player-leave.md": [
		10129,
		1,
		129
	],
	"./ultramotd.com/wiki/events/player-pickup-arrow.md": [
		88051,
		1,
		8051
	],
	"./ultramotd.com/wiki/events/player-portal.md": [
		95465,
		1,
		5465
	],
	"./ultramotd.com/wiki/events/player-shear-entity.md": [
		26289,
		1,
		6289
	],
	"./ultramotd.com/wiki/events/player-teleport.md": [
		14966,
		1,
		368
	],
	"./ultramotd.com/wiki/events/player-toggle-flight.md": [
		58366,
		1,
		4687
	],
	"./ultramotd.com/wiki/events/portal-create.md": [
		77127,
		1,
		7127
	],
	"./ultramotd.com/wiki/events/spawn-change.md": [
		75998,
		1,
		5998
	],
	"./ultramotd.com/wiki/events/weather-change.md": [
		24443,
		1,
		4443
	],
	"./ultramotd.com/wiki/faq/index.md": [
		18230,
		1,
		8230
	],
	"./ultramotd.com/wiki/features/events.md": [
		6261,
		1,
		6261
	],
	"./ultramotd.com/wiki/features/index.md": [
		49328,
		1,
		9328
	],
	"./ultramotd.com/wiki/features/maintenance_mode.md": [
		95023,
		1,
		5023
	],
	"./ultramotd.com/wiki/features/server_motd.md": [
		85830,
		1,
		5830
	],
	"./ultramotd.com/wiki/features/timers.md": [
		41040,
		1,
		1040
	],
	"./ultramotd.com/wiki/features/welcome_message.md": [
		41159,
		1,
		1159
	],
	"./ultramotd.com/wiki/installation/index.md": [
		58434,
		1,
		8434
	],
	"./ultramotd.com/wiki/installation/proxy.md": [
		28703,
		1,
		8703
	],
	"./ultramotd.com/wiki/installation/server.md": [
		62782,
		1,
		2782
	],
	"./ultramotd.com/wiki/installation/troubleshooting.md": [
		22449,
		1,
		2449
	],
	"./ultramotd.com/wiki/overview/commands.md": [
		39161,
		1,
		9161
	],
	"./ultramotd.com/wiki/overview/index.md": [
		25691,
		1,
		5691
	],
	"./ultramotd.com/wiki/overview/permissions.md": [
		35741,
		1,
		5741
	],
	"./ultramotd.com/wiki/overview/placeholders.md": [
		84777,
		1,
		4777
	],
	"./ultramotd.com/wiki/wiki": [
		95717,
		3,
		5717
	],
	"./ultramotd.com/wiki/wiki.json": [
		95717,
		3,
		5717
	],
	"./ultrapermissions.com/config": [
		47558,
		3,
		7558
	],
	"./ultrapermissions.com/config.json": [
		47558,
		3,
		7558
	],
	"./ultrapermissions.com/images/1.gif": [
		35924,
		1,
		5924
	],
	"./ultrapermissions.com/images/2.gif": [
		80030,
		1,
		2844
	],
	"./ultrapermissions.com/images/3.gif": [
		79761,
		1,
		9761
	],
	"./ultrapermissions.com/images/4.gif": [
		39871,
		1,
		9871
	],
	"./ultrapermissions.com/images/banner.png": [
		96577,
		1,
		6577
	],
	"./ultrapermissions.com/images/logo.png": [
		20352,
		1,
		352
	],
	"./ultrapermissions.com/updates": [
		5061,
		3,
		5061
	],
	"./ultrapermissions.com/updates.json": [
		5061,
		3,
		5061
	],
	"./ultrapermissions.com/wiki/api/dependency.md": [
		29122,
		1,
		9122
	],
	"./ultrapermissions.com/wiki/api/gradle.md": [
		12531,
		1,
		2531
	],
	"./ultrapermissions.com/wiki/api/groups.md": [
		32927,
		1,
		2927
	],
	"./ultrapermissions.com/wiki/api/index.md": [
		23242,
		1,
		3242
	],
	"./ultrapermissions.com/wiki/api/instance.md": [
		90186,
		1,
		5919
	],
	"./ultrapermissions.com/wiki/api/maven.md": [
		61111,
		1,
		1111
	],
	"./ultrapermissions.com/wiki/api/permissions.md": [
		98819,
		1,
		8819
	],
	"./ultrapermissions.com/wiki/faq/index.md": [
		47132,
		1,
		7132
	],
	"./ultrapermissions.com/wiki/features/chat_formatting.md": [
		24466,
		1,
		4466
	],
	"./ultrapermissions.com/wiki/features/gradient.md": [
		50787,
		1,
		787
	],
	"./ultrapermissions.com/wiki/features/index.md": [
		79789,
		1,
		4944
	],
	"./ultrapermissions.com/wiki/features/offline_users.md": [
		24431,
		1,
		4431
	],
	"./ultrapermissions.com/wiki/features/perm_log.md": [
		84467,
		1,
		4467
	],
	"./ultrapermissions.com/wiki/features/permission_suggestions.md": [
		43146,
		1,
		3146
	],
	"./ultrapermissions.com/wiki/features/scoping.md": [
		67745,
		1,
		7745
	],
	"./ultrapermissions.com/wiki/features/tab_formatting.md": [
		45322,
		1,
		5322
	],
	"./ultrapermissions.com/wiki/features/temp_perms.md": [
		78443,
		1,
		8443
	],
	"./ultrapermissions.com/wiki/installation/import.md": [
		29783,
		1,
		9783
	],
	"./ultrapermissions.com/wiki/installation/index.md": [
		12470,
		1,
		2470
	],
	"./ultrapermissions.com/wiki/installation/language.md": [
		22637,
		1,
		2637
	],
	"./ultrapermissions.com/wiki/installation/mariadb.md": [
		92954,
		1,
		2954
	],
	"./ultrapermissions.com/wiki/installation/proxy.md": [
		61028,
		1,
		1028
	],
	"./ultrapermissions.com/wiki/installation/server.md": [
		14962,
		1,
		4962
	],
	"./ultrapermissions.com/wiki/installation/troubleshooting.md": [
		14421,
		1,
		4421
	],
	"./ultrapermissions.com/wiki/overview/commands.md": [
		88287,
		1,
		8287
	],
	"./ultrapermissions.com/wiki/overview/index.md": [
		68767,
		1,
		8767
	],
	"./ultrapermissions.com/wiki/overview/permissions.md": [
		36204,
		1,
		6204
	],
	"./ultrapermissions.com/wiki/overview/placeholders.md": [
		15010,
		1,
		5010
	],
	"./ultrapermissions.com/wiki/wiki": [
		65124,
		3,
		5124
	],
	"./ultrapermissions.com/wiki/wiki.json": [
		65124,
		3,
		5124
	],
	"./ultrapunishments.com/config": [
		45756,
		3,
		5756
	],
	"./ultrapunishments.com/config.json": [
		45756,
		3,
		5756
	],
	"./ultrapunishments.com/images/1.gif": [
		12748,
		1,
		2748
	],
	"./ultrapunishments.com/images/2.gif": [
		49224,
		1,
		9224
	],
	"./ultrapunishments.com/images/3.gif": [
		49078,
		1,
		9078
	],
	"./ultrapunishments.com/images/4.gif": [
		75521,
		1,
		5521
	],
	"./ultrapunishments.com/images/banner.png": [
		85661,
		1,
		5661
	],
	"./ultrapunishments.com/images/logo.png": [
		91353,
		1,
		1353
	],
	"./ultrapunishments.com/updates": [
		40025,
		3,
		25
	],
	"./ultrapunishments.com/updates.json": [
		40025,
		3,
		25
	],
	"./ultrapunishments.com/wiki/api/index.md": [
		4555,
		1,
		4555
	],
	"./ultrapunishments.com/wiki/faq/index.md": [
		28602,
		1,
		8602
	],
	"./ultrapunishments.com/wiki/features/index.md": [
		97856,
		1,
		7856
	],
	"./ultrapunishments.com/wiki/installation/index.md": [
		2523,
		1,
		2523
	],
	"./ultrapunishments.com/wiki/installation/language.md": [
		31174,
		1,
		1174
	],
	"./ultrapunishments.com/wiki/installation/proxy.md": [
		66488,
		1,
		6488
	],
	"./ultrapunishments.com/wiki/installation/server.md": [
		88860,
		1,
		8860
	],
	"./ultrapunishments.com/wiki/installation/troubleshooting.md": [
		99957,
		1,
		5436
	],
	"./ultrapunishments.com/wiki/overview/commands.md": [
		65687,
		1,
		5687
	],
	"./ultrapunishments.com/wiki/overview/index.md": [
		41391,
		1,
		1391
	],
	"./ultrapunishments.com/wiki/overview/permissions.md": [
		76104,
		1,
		6104
	],
	"./ultrapunishments.com/wiki/overview/placeholders.md": [
		68838,
		1,
		8838
	],
	"./ultrapunishments.com/wiki/wiki": [
		22116,
		3,
		2116
	],
	"./ultrapunishments.com/wiki/wiki.json": [
		22116,
		3,
		2116
	],
	"./ultraregions.com/config": [
		22114,
		3,
		2114
	],
	"./ultraregions.com/config.json": [
		22114,
		3,
		2114
	],
	"./ultraregions.com/images/1.gif": [
		94455,
		1,
		4455
	],
	"./ultraregions.com/images/2.gif": [
		51869,
		1,
		1869
	],
	"./ultraregions.com/images/3.gif": [
		55001,
		1,
		5001
	],
	"./ultraregions.com/images/banner.png": [
		37937,
		1,
		7937
	],
	"./ultraregions.com/images/logo.png": [
		7604,
		1,
		7604
	],
	"./ultraregions.com/updates": [
		66860,
		3,
		6860
	],
	"./ultraregions.com/updates.json": [
		66860,
		3,
		6860
	],
	"./ultraregions.com/wiki/addons/aureliumskillsflags.md": [
		45098,
		1,
		5098
	],
	"./ultraregions.com/wiki/addons/commanddeny.md": [
		7112,
		1,
		7112
	],
	"./ultraregions.com/wiki/addons/containeraddon.md": [
		16234,
		1,
		6234
	],
	"./ultraregions.com/wiki/addons/croptrample.md": [
		99553,
		1,
		9553
	],
	"./ultraregions.com/wiki/addons/death.md": [
		78585,
		1,
		8585
	],
	"./ultraregions.com/wiki/addons/denysleep.md": [
		41753,
		1,
		1753
	],
	"./ultraregions.com/wiki/addons/ecoskillsflags.md": [
		44129,
		1,
		4129
	],
	"./ultraregions.com/wiki/addons/enterandleaveflags.md": [
		43717,
		1,
		3717
	],
	"./ultraregions.com/wiki/addons/entryandexitflags.md": [
		60538,
		1,
		538
	],
	"./ultraregions.com/wiki/addons/extrablockflags.md": [
		68812,
		1,
		8812
	],
	"./ultraregions.com/wiki/addons/flyflag.md": [
		68271,
		1,
		8271
	],
	"./ultraregions.com/wiki/addons/index.md": [
		60898,
		1,
		898
	],
	"./ultraregions.com/wiki/addons/keepinventory.md": [
		9518,
		1,
		9518
	],
	"./ultraregions.com/wiki/addons/mcmmoflags.md": [
		78702,
		1,
		1344
	],
	"./ultraregions.com/wiki/api/index.md": [
		77417,
		1,
		7417
	],
	"./ultraregions.com/wiki/faq/index.md": [
		73647,
		1,
		3647
	],
	"./ultraregions.com/wiki/features/index.md": [
		69270,
		1,
		9270
	],
	"./ultraregions.com/wiki/flags/block-breaking.md": [
		20107,
		1,
		107
	],
	"./ultraregions.com/wiki/flags/block-burning.md": [
		42196,
		1,
		2196
	],
	"./ultraregions.com/wiki/flags/block-explotion-damage.md": [
		1457,
		1,
		1457
	],
	"./ultraregions.com/wiki/flags/block-igniting.md": [
		27975,
		1,
		7975
	],
	"./ultraregions.com/wiki/flags/block-interactions.md": [
		86544,
		1,
		6544
	],
	"./ultraregions.com/wiki/flags/block-placing.md": [
		64579,
		1,
		4579
	],
	"./ultraregions.com/wiki/flags/chatting.md": [
		24715,
		1,
		4715
	],
	"./ultraregions.com/wiki/flags/chorus-fruit.md": [
		26428,
		1,
		6428
	],
	"./ultraregions.com/wiki/flags/contact-damage.md": [
		31003,
		1,
		1003
	],
	"./ultraregions.com/wiki/flags/crafting.md": [
		59424,
		1,
		9424
	],
	"./ultraregions.com/wiki/flags/cramming-damage.md": [
		99145,
		1,
		9145
	],
	"./ultraregions.com/wiki/flags/creature-spawning.md": [
		80142,
		1,
		142
	],
	"./ultraregions.com/wiki/flags/crop-trampling.md": [
		31759,
		1,
		1759
	],
	"./ultraregions.com/wiki/flags/custom-damage.md": [
		34073,
		1,
		4073
	],
	"./ultraregions.com/wiki/flags/dragon-breath-damage.md": [
		13217,
		1,
		3217
	],
	"./ultraregions.com/wiki/flags/drowning-damage.md": [
		77197,
		1,
		7197
	],
	"./ultraregions.com/wiki/flags/dryout-damage.md": [
		70305,
		1,
		305
	],
	"./ultraregions.com/wiki/flags/entity-attack-damage.md": [
		22401,
		1,
		2401
	],
	"./ultraregions.com/wiki/flags/entity-explosion-damage.md": [
		19432,
		1,
		9432
	],
	"./ultraregions.com/wiki/flags/entity-sweep-attack-damage.md": [
		13169,
		1,
		3169
	],
	"./ultraregions.com/wiki/flags/entry-deny.md": [
		72113,
		1,
		2113
	],
	"./ultraregions.com/wiki/flags/entry-exit.md": [
		44821,
		1,
		4821
	],
	"./ultraregions.com/wiki/flags/explosion-block-damage.md": [
		51852,
		1,
		1852
	],
	"./ultraregions.com/wiki/flags/fall-damage.md": [
		84940,
		1,
		4940
	],
	"./ultraregions.com/wiki/flags/falling-block-damage.md": [
		27051,
		1,
		7051
	],
	"./ultraregions.com/wiki/flags/fire-charge-create.md": [
		75588,
		1,
		5588
	],
	"./ultraregions.com/wiki/flags/fire-charge-fire.md": [
		24203,
		1,
		4203
	],
	"./ultraregions.com/wiki/flags/fire-damage.md": [
		3661,
		1,
		3661
	],
	"./ultraregions.com/wiki/flags/fire-spread.md": [
		75274,
		1,
		5274
	],
	"./ultraregions.com/wiki/flags/fire-tick-damage.md": [
		70030,
		1,
		30
	],
	"./ultraregions.com/wiki/flags/fly-into-wall-damage.md": [
		84385,
		1,
		4385
	],
	"./ultraregions.com/wiki/flags/food-change.md": [
		1106,
		1,
		1106
	],
	"./ultraregions.com/wiki/flags/freeze-damage.md": [
		34350,
		1,
		4350
	],
	"./ultraregions.com/wiki/flags/hostile-mob-spawn.md": [
		8176,
		1,
		8176
	],
	"./ultraregions.com/wiki/flags/hot-floor-damage.md": [
		82609,
		1,
		2609
	],
	"./ultraregions.com/wiki/flags/index.md": [
		82361,
		1,
		2361
	],
	"./ultraregions.com/wiki/flags/insane-shops-shops-creation.md": [
		30617,
		1,
		617
	],
	"./ultraregions.com/wiki/flags/item-drop.md": [
		18711,
		1,
		8711
	],
	"./ultraregions.com/wiki/flags/item-frame-interact.md": [
		49893,
		1,
		9893
	],
	"./ultraregions.com/wiki/flags/item-merging.md": [
		93441,
		1,
		3441
	],
	"./ultraregions.com/wiki/flags/item-pickup.md": [
		20654,
		1,
		654
	],
	"./ultraregions.com/wiki/flags/lava-damage.md": [
		44519,
		1,
		4519
	],
	"./ultraregions.com/wiki/flags/lava-flow.md": [
		86047,
		1,
		6047
	],
	"./ultraregions.com/wiki/flags/lightning-damage.md": [
		33068,
		1,
		3068
	],
	"./ultraregions.com/wiki/flags/magic-damage.md": [
		13742,
		1,
		3742
	],
	"./ultraregions.com/wiki/flags/melting-damage.md": [
		56889,
		1,
		6889
	],
	"./ultraregions.com/wiki/flags/peaceful-mob-spawn.md": [
		30089,
		1,
		89
	],
	"./ultraregions.com/wiki/flags/portals.md": [
		70845,
		1,
		845
	],
	"./ultraregions.com/wiki/flags/potion-consume.md": [
		67988,
		1,
		7988
	],
	"./ultraregions.com/wiki/flags/potion-damage.md": [
		49886,
		1,
		9886
	],
	"./ultraregions.com/wiki/flags/potion-splash.md": [
		91461,
		1,
		1461
	],
	"./ultraregions.com/wiki/flags/projectile-damage.md": [
		78272,
		1,
		8272
	],
	"./ultraregions.com/wiki/flags/pve.md": [
		49954,
		1,
		9954
	],
	"./ultraregions.com/wiki/flags/pvp.md": [
		37964,
		1,
		7964
	],
	"./ultraregions.com/wiki/flags/starvation-damage.md": [
		45481,
		1,
		5481
	],
	"./ultraregions.com/wiki/flags/suffocation-damage.md": [
		33244,
		1,
		3244
	],
	"./ultraregions.com/wiki/flags/suicide-damage.md": [
		6130,
		1,
		6130
	],
	"./ultraregions.com/wiki/flags/thorns-damage.md": [
		44127,
		1,
		4127
	],
	"./ultraregions.com/wiki/flags/void-damage.md": [
		20284,
		1,
		284
	],
	"./ultraregions.com/wiki/flags/water-flow.md": [
		30664,
		1,
		664
	],
	"./ultraregions.com/wiki/flags/wither-damage.md": [
		66769,
		1,
		6769
	],
	"./ultraregions.com/wiki/installation/index.md": [
		4853,
		1,
		4853
	],
	"./ultraregions.com/wiki/installation/language.md": [
		21378,
		1,
		1378
	],
	"./ultraregions.com/wiki/installation/server.md": [
		29775,
		1,
		9775
	],
	"./ultraregions.com/wiki/overview/commands.md": [
		71073,
		1,
		1073
	],
	"./ultraregions.com/wiki/overview/index.md": [
		35175,
		1,
		5175
	],
	"./ultraregions.com/wiki/overview/permissions.md": [
		73279,
		1,
		3279
	],
	"./ultraregions.com/wiki/overview/placeholders.md": [
		52094,
		1,
		2094
	],
	"./ultraregions.com/wiki/wiki": [
		38498,
		3,
		8498
	],
	"./ultraregions.com/wiki/wiki.json": [
		38498,
		3,
		8498
	],
	"./ultrascoreboards.com/config": [
		92439,
		3,
		2439
	],
	"./ultrascoreboards.com/config.json": [
		92439,
		3,
		2439
	],
	"./ultrascoreboards.com/images/1.gif": [
		12017,
		1,
		2017
	],
	"./ultrascoreboards.com/images/2.gif": [
		65545,
		1,
		5545
	],
	"./ultrascoreboards.com/images/3.gif": [
		11068,
		1,
		1068
	],
	"./ultrascoreboards.com/images/4.gif": [
		25788,
		1,
		5788
	],
	"./ultrascoreboards.com/images/banner.png": [
		48273,
		1,
		8273
	],
	"./ultrascoreboards.com/images/logo.png": [
		35855,
		1,
		5855
	],
	"./ultrascoreboards.com/updates": [
		51302,
		3,
		1547
	],
	"./ultrascoreboards.com/updates.json": [
		51302,
		3,
		1547
	],
	"./ultrascoreboards.com/wiki/api/index.md": [
		85793,
		1,
		5793
	],
	"./ultrascoreboards.com/wiki/faq/index.md": [
		40250,
		1,
		250
	],
	"./ultrascoreboards.com/wiki/features/index.md": [
		64694,
		1,
		4694
	],
	"./ultrascoreboards.com/wiki/installation/index.md": [
		38702,
		1,
		8702
	],
	"./ultrascoreboards.com/wiki/installation/language.md": [
		97506,
		1,
		7506
	],
	"./ultrascoreboards.com/wiki/installation/proxy.md": [
		49726,
		1,
		9726
	],
	"./ultrascoreboards.com/wiki/installation/server.md": [
		19741,
		1,
		9741
	],
	"./ultrascoreboards.com/wiki/installation/troubleshooting.md": [
		99233,
		1,
		9233
	],
	"./ultrascoreboards.com/wiki/overview/commands.md": [
		15629,
		1,
		5629
	],
	"./ultrascoreboards.com/wiki/overview/index.md": [
		79057,
		1,
		7139
	],
	"./ultrascoreboards.com/wiki/overview/permissions.md": [
		28334,
		1,
		8334
	],
	"./ultrascoreboards.com/wiki/wiki": [
		13670,
		3,
		3670
	],
	"./ultrascoreboards.com/wiki/wiki.json": [
		13670,
		3,
		3670
	],
	"./wiki.techscode.com/config": [
		10367,
		3,
		367
	],
	"./wiki.techscode.com/config.json": [
		10367,
		3,
		367
	],
	"./wiki.techscode.com/images/logo.png": [
		83749,
		1,
		3749
	],
	"./wiki.techscode.com/wiki/overview/index.md": [
		64521,
		1,
		4521
	],
	"./wiki.techscode.com/wiki/wiki": [
		22403,
		3,
		2403
	],
	"./wiki.techscode.com/wiki/wiki.json": [
		22403,
		3,
		2403
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2]).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 35517;
module.exports = webpackAsyncContext;